import { render, staticRenderFns } from "./assetsWarehousing.vue?vue&type=template&id=2741a56c&scoped=true&"
import script from "./assetsWarehousing.vue?vue&type=script&lang=js&"
export * from "./assetsWarehousing.vue?vue&type=script&lang=js&"
import style0 from "./assetsWarehousing.vue?vue&type=style&index=0&id=2741a56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2741a56c",
  null
  
)

export default component.exports